import {InjectionToken} from "@angular/core";


export const SIDE_PANEL_DATA = new InjectionToken<any>('SIDE_PANEL_DATA')
